import axios from "axios";
import { successHandling } from "../helpers/successHandling";

export const createFolderAPI = async (
  name,
  parentId,
  t,
  onClose,
  setIsFolderExisted,
  setErrorText,
  reloadTable
) => {
  try {
    await axios({
      url: `/api/v2/drive/file/create-folder`,
      method: "GET",
      params: {
        name: name,
        parent_id: parentId
      }
    });
    const successfulText = `${t("dialog.successfullyCreateFolder")}`;
    successHandling(t, successfulText);
    onClose();
    reloadTable();
    return true;
  } catch (error) {
    setIsFolderExisted(true);
    setErrorText(`${t(`dialog.${error.response.data.errors.name[0]}`)}`);
  }
};
